import { apiFromBafsy } from '@/api/axiosBafsy';
import { EmailSenderConfig } from '@/types/types';

/**
 * Отправляет письмо
 * @param params конфиг для отправки {'email[subject]': 'тема письма',
               'email[from][name]': 'Имя отправителя',
               'email[from][email]': 'Почта отправителя',
               'email[to][][email]': 'Почта адресата',
               'email[html]': 'Тело письма, поддерживает html-теги'}
 * @returns возвращает Promise
 */
async function sendEmailLetter(params: EmailSenderConfig) {
  return apiFromBafsy.excuteRequest('POST', 'api/email/delivery', params);
}

export { sendEmailLetter };
